<template>
  <AppSpinner
    v-if="authStore.loading"
    class="page-spinner"
  />

  <template v-else>
    <RouterView />

    <TransitionGroup name="slide-fade">
      <AppToast
        v-for="toast in toastStore.toasts"
        :key="toast.id"
        :message="toast.message"
        :type="toast.type"
        @dismissed="toastStore.remove(toast.id)"
      />
    </TransitionGroup>
  </template>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';

import { useAuthStore, useToastStore } from '@/store';
import { AppSpinner, AppToast } from '@/components/app';

const authStore = useAuthStore();
const toastStore = useToastStore();

const route = useRoute();
const router = useRouter();

if (route.path === '/') {
  router.push({ name: 'app_event_list' });
}

</script>
